import { Card, RadioChangeEvent, Row, Spin } from "antd";
import { useCallback, useState } from "react";
import { Header } from "./components/Header";
import { useFetchData } from "./hooks/useFetchData";
import { Column } from "@ant-design/plots";
import { usePlotConfig } from "./hooks/usePlotConfig";

type TransactionByMethodProps = {
  isRecalculated: boolean;
};

export const TransactionByMethod = ({
  isRecalculated,
}: TransactionByMethodProps) => {
  const [granularity, setGranularity] = useState<number>(2);

  const [source, setSource] = useState<1 | 2>(1);

  const onSourceChange = useCallback(
    (e: RadioChangeEvent) => setSource(e.target.value),
    [],
  );

  const { isLoading, data } = useFetchData(granularity, source, isRecalculated);

  const { config } = usePlotConfig(data);

  return (
    <Card className="dashboard-card top">
      <Header
        granularity={granularity}
        source={source}
        setGranularity={setGranularity}
        onSourceChange={onSourceChange}
      />
      {!isLoading ? (
        <Row className="d-block mt-4">
          {data.length > 0 ? (
            <Column {...config} />
          ) : (
            <Row className="w-100 mt-10 pt-10 justify-center">
              <p className="my-0 text title">No Data</p>
            </Row>
          )}
        </Row>
      ) : (
        <Row className="h-100 justify-center align-center">
          <Spin size="large" />
        </Row>
      )}
    </Card>
  );
};
